export default "__VITE_ASSET__BIAMCTiv__"